const choices = {
    fullOwnership: 'Pleine propriété',
    jointPossession: 'Indivision',
    bareOwnership: 'Nue propriété',
    usufruct: 'Usufruit',
    lifetime: 'Viager',
};

export default choices;
